import React, { useEffect, useState } from "react";

/**
 * Avatar con fallback sobrio: silueta monocroma, sin ilustración ni colores.
 *
 * Hubo un tiempo en que el backend asignaba a todos una imagen de dibujos
 * alojada fuera; esas URLs siguen guardadas en usuarios antiguos, así que las
 * tratamos como "sin foto" para que caigan en este fallback.
 */

const PLACEHOLDERS = [
  "icons.veryicon.com",
  "via.placeholder.com",
  "placeholder.com",
];

const isRealPhoto = (src) => {
  if (!src || typeof src !== "string") return false;
  const value = src.trim();
  if (!value || value === "undefined" || value === "null") return false;
  return !PLACEHOLDERS.some((host) => value.includes(host));
};

function Avatar({
  src,
  name = "",
  surname = "",
  size = 48,
  ring = false,
  className = "",
  style = {},
  ...rest
}) {
  const [failed, setFailed] = useState(false);

  // Sin esto, una foto que falla deja el fallback fijado y la siguiente que se
  // elija (por ejemplo al editar el perfil) no llega a mostrarse nunca.
  useEffect(() => setFailed(false), [src]);

  const label = `${name} ${surname}`.trim();
  const showPhoto = isRealPhoto(src) && !failed;

  const avatar = (
    <div
      className={`dyd-avatar ${className}`}
      style={{ width: size, height: size, ...style }}
      title={label || undefined}
      {...rest}
    >
      {showPhoto ? (
        <img src={src} alt={label || "Avatar"} onError={() => setFailed(true)} />
      ) : (
        <svg
          viewBox="0 0 40 40"
          width="100%"
          height="100%"
          role="img"
          aria-label={label ? `Avatar de ${label}` : "Avatar"}
        >
          <circle cx="20" cy="15.4" r="6.2" fill="currentColor" />
          <path
            d="M20 23.6c-6.3 0-11.4 4.1-11.4 9.2V40h22.8v-7.2c0-5.1-5.1-9.2-11.4-9.2z"
            fill="currentColor"
          />
        </svg>
      )}
    </div>
  );

  if (!ring) return avatar;

  return <div className="dyd-avatar-ring">{avatar}</div>;
}

export default Avatar;
